import { LucideProps } from 'lucide-react';
import { cn } from '../util';

interface IconProps {
  type: React.FunctionComponent<React.SVGProps<SVGSVGElement> & LucideProps>;
  size?: 'sm' | 'm' | 'l' | 'fillParent';
  className?: string;
}

export const Icon = ({ type: IconType, size = 'm', className }: IconProps) => {
  return <IconType size={getIconSize(size)} className={cn(size === 'fillParent' && 'h-full w-full', className)} />;
};

const getIconSize = (size: 'sm' | 'm' | 'l' | 'fillParent') => {
  switch (size) {
    case 'sm':
      return 12;
    case 'm':
      return 16;
    case 'l':
      return 24;
    case 'fillParent':
      return undefined;
    default:
      return 16;
  }
};
